import Icon from "./IconBase.js";

const NotiificationNoDataIcon = (props) => {
  return (
    <Icon width="40" height="40" viewBox="0 0 40 40" {...props}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.7717 21.8025L29.7696 18.6467C29.7694 16.5139 28.9882 14.4435 27.5522 12.7704C26.1162 11.0973 24.1094 9.91922 21.8563 9.42677C21.8734 9.36557 21.8867 9.30351 21.8962 9.24091L21.8934 5.09637C21.8931 4.6314 21.6922 4.18561 21.335 3.85706C20.9778 3.52851 20.4935 3.34413 19.9887 3.34446C19.4839 3.3448 18.9998 3.52984 18.6431 3.85886C18.2863 4.18789 18.0861 4.63395 18.0864 5.09893L18.0892 9.24346C18.0987 9.30605 18.1121 9.36809 18.1293 9.42927C15.8769 9.92474 13.8716 11.1055 12.4379 12.7805C11.0041 14.4555 10.2257 16.527 10.2284 18.6598L10.2305 21.8156C10.2333 25.9987 6.68018 27.046 6.68159 29.1375C6.68228 30.1771 6.68299 31.2291 7.70706 31.2284L32.3077 31.2119C33.3318 31.2112 33.3311 30.1593 33.3304 29.1196C33.329 27.0281 29.7745 25.9856 29.7717 21.8025Z"
          fill="#757575"
        />
        <path
          d="M13.9612 32.9774C14.4669 34.0693 15.31 35.0002 16.3857 35.6541C17.4613 36.3081 18.7221 36.6563 20.011 36.6555C21.3 36.6546 22.5603 36.3047 23.635 35.6493C24.7098 34.9939 25.5517 34.0619 26.0559 32.9693L13.9612 32.9774Z"
          fill="#757575"
        />
      </svg>
    </Icon>
  );
};

export default NotiificationNoDataIcon;
